<app-header [pageTitle]="pageTitle" (back)="backToLeaveSyndicate()"></app-header>
<ion-content>
  <div class="upper-content-wrapper">
    <p class="tom-syndicate">{{syndicateName}}</p>
  </div>
  <div class="lower-content-wrapper">
    <p class="emoji">🤔</p>
    <p class="reason-heading"> {{'dont-understand.Don’t' | translate}}</p>
    <div class="reason-content leave-wrapper">
      <p [innerHTML]="'dont-understand.lucky' | translate"></p>
      <a class="blue-link" href="https://support.lottosocial.com/how-does-lottosocial-work/">
        {{ 'dont-understand.plus bonus' | translate }}
      </a>
    </div>
  </div>
  <ion-row class="lower-most-content">
    <ion-col class="still-leave-wrap">
      <p class="still-leave" (click)="leave()"> {{'dont-understand.leave' | translate}}</p>
    </ion-col>
  </ion-row>
</ion-content>
